import { Loader2, CheckCircle2, XCircle } from "lucide-react";

interface TestResult {
  success: boolean;
  error?: string;
  latencyMs: number;
}

interface ConnectionTestResultProps {
  result: TestResult | null;
  isTesting: boolean;
}

export function ConnectionTestResult({
  result,
  isTesting,
}: ConnectionTestResultProps) {
  if (isTesting) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-border bg-card px-4 py-3">
        <Loader2 className="h-4 w-4 animate-spin text-accent" />
        <span className="text-[13px] text-secondary">
          Testing connection...
        </span>
      </div>
    );
  }

  if (!result) {
    return null;
  }

  if (result.success) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-green-200 bg-green-50 px-4 py-3">
        <CheckCircle2 className="h-4 w-4 text-green-600" />
        <span className="text-[13px] text-green-700">
          Connected successfully ({result.latencyMs}ms)
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
      <XCircle className="h-4 w-4 text-red-600" />
      <span className="text-[13px] text-red-700">
        {result.error ?? "Connection failed"}
      </span>
    </div>
  );
}
